import { createStore, getActionIds } from '../helpers/redux';
import Immutable, { List } from 'immutable';
import { AuthActions } from '../actions/auth';
import { ProjectActions } from '../actions/project';
// import { CommentActions } from '../actions/comment';

// import { elementTypesSelector } from './elementTypes';

const authActions = getActionIds(AuthActions);
// const commentActions = getActionIds(CommentActions);
const actions = getActionIds(ProjectActions);

const initialState = Immutable.fromJS({
  projects: {},
  loadedAll: false,
  loadingAll: false,
  loading: {
    projects: [],
    tags: [],
    comments: [],
  },
  loaded: {
    projects: [],
    tags: [],
    comments: [],
  },
  rootElementId: null,
  currentProjectId: null,
  showModal: false,
  isSubmitting: false,
  isCopying: false,
});

export const projects = createStore(initialState, {
  [actions.resetReducers]: (state, action) => {
    return state.mergeDeep({
      rootElementId: null,
      currentProjectId: null,
      showModal: false,
      isSubmitting: false,
      isCopying: false,
    });
  },

  [authActions.getMeProjects.begin]: (state, action) => {
    return state.mergeDeep({
      loadedAll: false,
      loadingAll: true,
    });
  },

  [authActions.getMeProjects.failure]: (state, action) => {
    return state.mergeDeep({
      loadedAll: false,
      loadingAll: false,
    });
  },

  [authActions.getMeProjects.success]: (state, action) => {
    if (!action.result.entities.projects) {
      return state.mergeDeep({
        loadedAll: true,
        loadingAll: false,
      });
    }

    return state.mergeDeep({
      projects: action.result.entities.projects,
      loadedAll: true,
      loadingAll: false,
    });
  },

  [actions.setCurrentProjectId]: (state, action) => {
    return state.merge({
      currentProjectId: action.projectId,
    });
  },

  [actions.getRootElement.success]: (state, action) => {
    return state.mergeDeep({
      rootElementId: action.result.result,
    });
  },

  [actions.getProject.begin]: (state, action) => {
    const projectId = action.args[0];
    return state.mergeDeep({
      loading: {
        projects: [projectId, ...state.getIn(['loading', 'projects'], List())],
      },
    });
  },

  // [actions.sortData]: (state, action) => {
  //   const sortOn = action.sortOn;

  //   if(sortOn != "projects") return state;

  //   const sortType = action.sortType;

  //   let projects = state.get('projects').sort((a,b) => {
  //     let lowerCaseA = a.get('name').toLowerCase();
  //     let lowerCaseB = b.get('name').toLowerCase();

  //     switch(sortType){
  //       case "ascending":
  //         if(lowerCaseA < lowerCaseB){
  //           return -1;
  //         } else if (lowerCaseA > lowerCaseB){
  //           return 1;
  //         } else {
  //           return 0
  //         }
  //       case "descending":
  //         if(lowerCaseA < lowerCaseB){
  //           return 1;
  //         } else if (lowerCaseA > lowerCaseB){
  //           return -1;
  //         } else {
  //           return 0
  //         }
  //       case "date":
  //         if(a.get('created_at') > b.get('created_at')){
  //           return -1;
  //         } else if (a.get('created_at') < b.get('created_at')){
  //           return 1;
  //         } else {
  //           return 0
  //         }
  //     }
  //   })

  //   debugger;

  //   return state.merge({
  //     projects: projects
  //   })
  // },

  [actions.getProject.success]: (state, action) => {
    return state.mergeDeep({
      // loaded: true,
      // loading: false,
      projects: action.result.entities.projects,
    });
  },

  [actions.getProjects.begin]: (state, action) => {
    return state;
    // return state.merge({
    //   loaded: false,
    //   loading: true
    // });
  },

  [actions.getProjects.success]: (state, action) => {
    return state.mergeDeep({
      // loaded: true,
      // loading: false,
      projects: action.result.entities.projects,
    });
  },

  [actions.getProjects.failure]: (state, action) => {
    return state;
    // return state.merge({
    //   loaded: false,
    //   loading: false,
    // });
  },

  [actions.deleteProject.success]: (state, action) => {
    return state
      .set('currentProjectId', null)
      .deleteIn(['projects', action.result.id]);
  },

  [actions.createProject.begin]: (state, action) => {
    return state.merge({
      isSubmitting: true,
    });
  },

  [actions.createProject.success]: (state, action) => {
    return state.mergeDeep({
      isSubmitting: false,
      projects: action.result.entities.projects,
      // projects: state.get('projects').unshift(action.result)
    });
  },

  [actions.createProject.failure]: (state, action) => {
    return state.merge({
      isSubmitting: false,
    });
  },

  [actions.importJSONProject.begin]: (state, action) => {
    return state.merge({
      isSubmitting: true,
    });
  },

  [actions.importJSONProject.success]: (state, action) => {
    return state.mergeDeep({
      isSubmitting: false,
      projects: action.result.entities.projects,
      // projects: state.get('projects').unshift(action.result)
    });
  },

  [actions.importJSONProject.failure]: (state, action) => {
    return state.merge({
      isSubmitting: false,
    });
  },

  [actions.copyProject.begin]: (state, action) => {
    return state.mergeDeep({
      isCopying: action.args[0],
    });
  },

  [actions.copyProject.success]: (state, action) => {
    return state.mergeDeep({
      isCopying: false,
      projects: action.result.entities.projects,
      // projects: state.get('projects').unshift(action.result)
    });
  },

  [actions.copyProject.failure]: (state, action) => {
    return state.mergeDeep({
      isCopying: false,
    });
  },

  [actions.renameProject.success]: (state, action) => {
    return state.mergeDeep({
      projects: {
        [action.result.result]: {
          name: action.result.entities.projects[action.result.result].name,
        },
      },
    });
  },

  // {type: "4-suspendProject", projectId: "1569", isSuspended: true}
  [actions.suspendProject]: (state, action) => {
    return state.mergeDeep({
      projects: {
        [action.projectId]: {
          is_suspended: action.isSuspended,
        },
      },
    });
  },

  [actions.unsuspendProject]: (state, action) => {
    return state.mergeDeep({
      projects: {
        [action.projectId]: {
          is_suspended: action.isSuspended,
        },
      },
    });
  },

  [actions.saveDescription.success]: (state, action) => {
    return state.mergeDeep({
      projects: {
        [action.result.result]: {
          description:
            action.result.entities.projects[action.result.result].description,
        },
      },
    });
  },

  // [commentActions.getProjectComments.begin]: (state, action) => {
  //   const commentIds = state.getIn(['loading', 'comments']);
  //   return state.setIn(
  //     ['loading', 'comments'],
  //     commentIds.push(action.args[0]),
  //   );
  // },
  //
  // [commentActions.getProjectComments.success]: (state, action) => {
  //   const commentIds = state.getIn(['loaded', 'comments']);
  //   const loadingIndex = state
  //     .getIn(['loading', 'comments'])
  //     .findIndex(function(index) {
  //       return index === action.result.id;
  //     });
  //   let loadingIds = state.getIn(['loading', 'comments']);
  //   loadingIds = loadingIds.delete(loadingIndex);
  //   return state
  //     .setIn(['loaded', 'comments'], commentIds.push(action.result.id))
  //     .setIn(['loading', 'comments'], loadingIds);
  // },

  [actions.updateCustomProperty.success]: (state, action) => {
    const key = Object.keys(action.result.props)[0];
    const value = action.result.props[key];

    return state.setIn(
      ['projects', action.result.projectId, 'props', key, '_value'],
      Immutable.fromJS(value),
    );
  },

  [actions.createCustomProperty.success]: (state, action) => {
    const key = Object.keys(action.result.props)[0];
    const value = action.result.props[key];

    return state.mergeDeep({
      projects: {
        [action.result.projectId]: {
          props: {
            [key]: value,
          },
        },
      },
    });
  },

  [actions.renameProjectProperty.success]: (state, action) => {
    const projectId = action.result.projectId;
    const projectProps = state.getIn(['projects', projectId, 'props']);
    const oldPropData = projectProps.get(action.result.prop);
    let updatedProjectProps = projectProps.delete(action.result.prop);
    updatedProjectProps = updatedProjectProps.set(
      action.result.newPropKey,
      oldPropData,
    );
    return state.setIn(['projects', projectId, 'props'], updatedProjectProps);
  },

  [actions.deleteProjectProperty.success]: (state, action) => {
    return state.deleteIn([
      'projects',
      action.result.projectId,
      'props',
      action.result.prop,
    ]);
  },
});

export const currentProjectIdSelector = state =>
  state.projects.get('currentProjectId');

export const projectsLoadedAllSelector = state =>
  state.projects.get('loadedAll');

export const projectsLoadingAllSelector = state =>
  state.projects.get('loadingAll');

export const projectsSelector = state => state.projects;
export const projectsProjectsSelector = state => state.projects.get('projects');

export const currentProjectSelector = state => {
  const currentProjectId = currentProjectIdSelector(state);

  return state.projects.getIn(['projects', currentProjectId]);
};

export const rootElementIdSelector = state => {
  return state.projects.get('rootElementId');
};

export const roleSelector = state => {
  return state.projects.getIn([
    'projects',
    currentProjectIdSelector(state),
    'role',
  ]);
};

export const projectStartDateSelector = (state, props) => {
  const currentProjectId = currentProjectIdSelector(state);
  return state.projects.getIn(
    ['projects', currentProjectId, 'props', 'Start Date', '_value'],
    '2017-01-01',
  );
};

export const projectTimezoneIdSelector = (state, props) => {
  const currentProjectId = currentProjectIdSelector(state);
  return state.projects.getIn(
    ['projects', currentProjectId, 'props', 'Time Zone', '_value'],
    '86',
  );
};

export const projectCalendarSelector = (state, props) => {
  const currentProjectId = currentProjectIdSelector(state);
  return state.projects.getIn(
    ['projects', currentProjectId, 'props', 'Project Calendar', '_value'],
    [],
  );
};

// export const workBreakdownStructureSelector = state => {
//   const projectId = currentProjectIdSelector(state);
//   const elementTypes = elementTypesSelector(state);

//   return state.projects
//     .getIn(
//       [
//         'projects',
//         projectId,
//         'props',
//         'Work Breakdown Structure',
//         '_value',
//         '[ET]Types',
//       ],
//       List(),
//     )
//     .map(typeId => elementTypes.getIn([typeId, 'type'], 'Null'));
// };



// WEBPACK FOOTER //
// ./src/reducers/projects.js